import { Survey, SurveyCompletion } from "../../domain/entities/Survey"
import { Microsite } from "../../domain/entities/Microsite"
import { SurveyAnswer } from "../../domain/entities/SurveyAnswer"
import { MicrositeModel } from "./MicrositeModel"
import { SurveySectionModel } from "./SurveySectionModel"
import { UploadFile } from "antd"
import { SurveySection } from "../../domain/entities/SurveySection"

interface ContructorParams {
	id?: number
	title: string
	title_en: string
	title_ca: string
	description?: string
	description_en?: string
	description_ca?: string
	createdAt?: Date
	microsites?: MicrositeModel[]
	sections?: SurveySectionModel[]
	answers?: SurveyAnswer[]
	status?: boolean
	image?: string | UploadFile
	marketplaces?: ("ES" | "MX")[]
	surveyCompletitions?: SurveyCompletion[]
	adminRecommendation?: string
}
export class SurveyModel {
	public readonly id?: number
	public readonly title: string
	public readonly title_en: string
	public readonly title_ca: string
	public readonly description?: string
	public readonly description_en?: string
	public readonly description_ca?: string
	public readonly createdAt?: Date
	public readonly microsites?: MicrositeModel[]
	public readonly sections?: SurveySectionModel[]
	public readonly answers?: SurveyAnswer[]
	public readonly status?: boolean
	public readonly image?: string | UploadFile
	public readonly marketplaces?: ("ES" | "MX")[]
	public readonly surveyCompletitions?: SurveyCompletion[]
	public readonly adminRecommendation?: string

	constructor(params: ContructorParams) {
		this.id = params.id
		this.title = params.title
		this.title_en = params.title_en
		this.title_ca = params.title_ca
		this.description = params.description
		this.description_en = params.description_en
		this.description_ca = params.description_ca
		this.createdAt = params.createdAt
		this.microsites = params.microsites
		this.sections = params.sections
		this.answers = params.answers
		this.status = params.status
		this.image = params.image
		this.marketplaces = params.marketplaces
		this.adminRecommendation = params.adminRecommendation
		this.surveyCompletitions = params.surveyCompletitions
	}

	static fromRawJson = (rawJson: any): SurveyModel => {
		return new SurveyModel({
			...rawJson,
			microsites: rawJson.microsites?.map((microsite: any) => MicrositeModel.fromRawJson(microsite)) ?? [],
			sections: rawJson.sections?.map((section: any) => SurveySectionModel.fromRawJson(section)) ?? [],
			surveyCompletitions: rawJson.surveyCompletitions ?? []
		})
	}

	static fromDomain = (survey: Survey): SurveyModel => {
		return new SurveyModel({
			...survey,
			microsites: survey.microsites?.map((microsite: Microsite) => MicrositeModel.fromDomain(microsite)) ?? [],
			sections: survey.sections?.map((section: SurveySection) => SurveySectionModel.fromDomain(section)) ?? [],
			surveyCompletitions: survey.surveyCompletitions ?? []
		})
	}

	toDomain(): Survey {
		return new Survey({
			id: this.id,
			microsites: this.microsites?.map(microsite => microsite.toDomain()) ?? [],
			title: this.title,
			title_en: this.title_en,
			title_ca: this.title_ca,
			description: this.description,
			description_en: this.description_en,
			description_ca: this.description_ca,
			createdAt: this.createdAt,
			sections: this.sections?.map(section => section.toDomain()) ?? [],
			answers: this.answers,
			status: this.status,
			image: this.image,
			marketplaces: this.marketplaces,
			adminRecommendation: this.adminRecommendation,
			surveyCompletitions: this.surveyCompletitions
		})
	}
}
